export default __webpack_public_path__ + "static/media/may-2021-international.9f4ffc9c.csv";